import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { Plus, UserPlus, GripVertical, Edit2, Trash2, CheckCircle, AlertTriangle, Clock, X } from 'lucide-react';
const PROCEDURE_TABS = [{
  label: 'Library',
  path: ''
}, {
  label: 'AI Agents',
  path: 'ai-agents'
}, {
  label: 'Onboarding',
  path: 'onboarding'
}, {
  label: 'Analytics',
  path: 'analytics'
}];
const TRAINEES = [{
  name: 'Ana M.',
  role: 'Kuvar',
  location: 'Vračar',
  start: 'Dec 8',
  progress: 67,
  modules: '8/12',
  score: '94%',
  status: 'active',
  lastActive: '2 hours ago'
}, {
  name: 'Marko P.',
  role: 'Konobar',
  location: 'BB',
  start: 'Dec 10',
  progress: 25,
  modules: '3/12',
  score: '88%',
  status: 'stalled',
  lastActive: '3 days ago'
}];
const MODULES = [{
  id: 1,
  title: 'Company Overview & Culture',
  type: 'Read',
  time: '15 min',
  critical: false
}, {
  id: 2,
  title: 'Food Safety & Hygiene',
  type: 'Read + Quiz',
  time: '30 min',
  critical: true,
  quiz: '10 questions'
}, {
  id: 3,
  title: 'Kitchen Equipment Basics',
  type: 'Practical',
  time: '45 min',
  critical: true,
  signoff: 'Manager'
}, {
  id: 4,
  title: 'Burger Station SOP',
  type: 'Read + Quiz',
  time: '20 min',
  critical: true,
  quiz: '5 questions'
}];
export function Onboarding() {
  const [showAddModal, setShowAddModal] = useState(false);
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-3108">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-3109">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-3110">Onboarding</h1>
        <Button icon={<UserPlus size={16} data-id="element-3112" />} onClick={() => setShowAddModal(true)} data-id="element-3111">
          Add New Hire
        </Button>
      </div>

      <TabNavigation tabs={PROCEDURE_TABS} basePath="/procedures" data-id="element-3113" />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-3114">
        {/* Trainees List */}
        <div className="lg:col-span-2 space-y-6" data-id="element-3115">
          <h3 className="font-bold text-text-secondary uppercase tracking-wider text-sm" data-id="element-3116">
            In Progress ({TRAINEES.length})
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3117">
            {TRAINEES.map((trainee, i) => <Card key={i} className="relative overflow-hidden" data-id="element-3118">
                {trainee.status === 'stalled' && <div className="absolute top-0 right-0 bg-accent-warning text-white text-[10px] font-bold px-2 py-1 rounded-bl-lg flex items-center gap-1" data-id="element-3119">
                    <AlertTriangle size={10} data-id="element-3120" /> Stalled
                  </div>}

                <div className="flex justify-between items-start mb-4" data-id="element-3121">
                  <div data-id="element-3122">
                    <h3 className="font-bold text-lg" data-id="element-3123">{trainee.name}</h3>
                    <div className="text-sm text-text-secondary" data-id="element-3124">
                      {trainee.role} · {trainee.location}
                    </div>
                  </div>
                  <div className="text-right" data-id="element-3125">
                    <div className="text-2xl font-bold text-accent-primary" data-id="element-3126">
                      {trainee.progress}%
                    </div>
                    <div className="text-xs text-text-secondary" data-id="element-3127">
                      {trainee.modules} modules
                    </div>
                  </div>
                </div>

                <div className="w-full h-2 bg-white/10 rounded-full mb-4 overflow-hidden" data-id="element-3128">
                  <div className="h-full bg-accent-primary rounded-full" style={{
                width: `${trainee.progress}%`
              }} data-id="element-3129"></div>
                </div>

                <div className="flex justify-between text-sm text-text-secondary mb-4" data-id="element-3130">
                  <span data-id="element-3131">
                    Avg Score:{' '}
                    <span className="text-accent-success font-bold" data-id="element-3132">
                      {trainee.score}
                    </span>
                  </span>
                  <span data-id="element-3133">Active: {trainee.lastActive}</span>
                </div>

                <div className="flex gap-2" data-id="element-3134">
                  <Button size="sm" variant="secondary" className="flex-1" data-id="element-3135">
                    View Details
                  </Button>
                  {trainee.status === 'stalled' && <Button size="sm" variant="secondary" className="flex-1 text-accent-warning border-accent-warning/20 hover:bg-accent-warning/10" data-id="element-3136">
                      Send Reminder
                    </Button>}
                </div>
              </Card>)}
          </div>

          <h3 className="font-bold text-text-secondary uppercase tracking-wider text-sm pt-4" data-id="element-3137">
            Completed This Month
          </h3>
          <Card noPadding data-id="element-3138">
            <table className="w-full text-sm" data-id="element-3139">
              <thead data-id="element-3140">
                <tr className="text-text-secondary border-b border-white/5" data-id="element-3141">
                  <th className="text-left p-4" data-id="element-3142">NAME</th>
                  <th className="text-left p-4" data-id="element-3143">ROLE</th>
                  <th className="text-left p-4" data-id="element-3144">LOCATION</th>
                  <th className="text-left p-4" data-id="element-3145">COMPLETED</th>
                  <th className="text-left p-4" data-id="element-3146">SCORE</th>
                </tr>
              </thead>
              <tbody data-id="element-3147">
                <tr className="border-b border-white/5 hover:bg-white/5" data-id="element-3148">
                  <td className="p-4 font-bold flex items-center gap-2" data-id="element-3149">
                    <CheckCircle size={16} className="text-accent-success" data-id="element-3150" />{' '}
                    Ana M.
                  </td>
                  <td className="p-4" data-id="element-3151">Kuvar</td>
                  <td className="p-4" data-id="element-3152">Vračar</td>
                  <td className="p-4" data-id="element-3153">Dec 8 (4 days)</td>
                  <td className="p-4 font-bold text-accent-success" data-id="element-3154">94%</td>
                </tr>
              </tbody>
            </table>
          </Card>
        </div>

        {/* Training Flow Editor */}
        <div className="space-y-4" data-id="element-3155">
          <div className="flex justify-between items-center" data-id="element-3156">
            <h3 className="font-bold text-text-secondary uppercase tracking-wider text-sm" data-id="element-3157">
              Kitchen Staff Flow (12)
            </h3>
            <Button size="sm" variant="secondary" data-id="element-3158">
              Edit Flow
            </Button>
          </div>

          <div className="space-y-2" data-id="element-3159">
            {MODULES.map((module, i) => <Card key={module.id} className="p-3 group cursor-grab active:cursor-grabbing hover:border-white/20 transition-colors" data-id="element-3160">
                <div className="flex gap-3" data-id="element-3161">
                  <GripVertical className="text-text-muted mt-1" size={16} data-id="element-3162" />
                  <div className="flex-1 min-w-0" data-id="element-3163">
                    <div className="flex justify-between items-start mb-1" data-id="element-3164">
                      <h4 className="font-bold text-sm truncate pr-2" data-id="element-3165">
                        {i + 1}. {module.title}
                      </h4>
                      {module.critical && <span className="text-[10px] font-bold text-accent-warning bg-accent-warning/10 px-1.5 py-0.5 rounded" data-id="element-3166">
                          Critical
                        </span>}
                    </div>
                    <div className="text-xs text-text-secondary flex flex-wrap gap-2" data-id="element-3167">
                      <span className="bg-white/5 px-1.5 py-0.5 rounded" data-id="element-3168">
                        {module.type}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-3169">
                        <Clock size={10} data-id="element-3170" /> {module.time}
                      </span>
                      {module.quiz && <span data-id="element-3171">· {module.quiz}</span>}
                    </div>
                  </div>
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity flex flex-col gap-1" data-id="element-3172">
                    <button className="p-1 hover:bg-white/10 rounded text-text-secondary" data-id="element-3173">
                      <Edit2 size={14} data-id="element-3174" />
                    </button>
                    <button className="p-1 hover:bg-white/10 rounded text-accent-error" data-id="element-3175">
                      <Trash2 size={14} data-id="element-3176" />
                    </button>
                  </div>
                </div>
              </Card>)}
            <Button variant="secondary" className="w-full border-dashed border-white/20" icon={<Plus size={14} data-id="element-3178" />} data-id="element-3177">
              Add Module
            </Button>
          </div>
        </div>
      </div>

      {/* Add New Hire Modal */}
      {showAddModal && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" data-id="element-3179">
          <Card className="w-full max-w-md" data-id="element-3180">
            <div className="flex justify-between items-center mb-6" data-id="element-3181">
              <h3 className="text-xl font-bold" data-id="element-3182">Add New Hire</h3>
              <button onClick={() => setShowAddModal(false)} className="text-text-secondary hover:text-white" data-id="element-3183">
                <X size={20} data-id="element-3184" />
              </button>
            </div>

            <div className="space-y-4 mb-6" data-id="element-3185">
              <div data-id="element-3186">
                <label className="block text-xs font-bold text-text-secondary uppercase mb-1" data-id="element-3187">
                  Name
                </label>
                <input type="text" className="w-full bg-background border border-white/10 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-accent-primary" placeholder="Full Name" data-id="element-3188" />
              </div>
              <div data-id="element-3189">
                <label className="block text-xs font-bold text-text-secondary uppercase mb-1" data-id="element-3190">
                  Phone (WhatsApp)
                </label>
                <input type="text" className="w-full bg-background border border-white/10 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-accent-primary" placeholder="+381..." data-id="element-3191" />
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-3192">
                <div data-id="element-3193">
                  <label className="block text-xs font-bold text-text-secondary uppercase mb-1" data-id="element-3194">
                    Role
                  </label>
                  <select className="w-full bg-background border border-white/10 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-accent-primary" data-id="element-3195">
                    <option data-id="element-3196">Kuvar</option>
                    <option data-id="element-3197">Konobar</option>
                    <option data-id="element-3198">Vođa smene</option>
                  </select>
                </div>
                <div data-id="element-3199">
                  <label className="block text-xs font-bold text-text-secondary uppercase mb-1" data-id="element-3200">
                    Location
                  </label>
                  <select className="w-full bg-background border border-white/10 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-accent-primary" data-id="element-3201">
                    <option data-id="element-3202">Vračar</option>
                    <option data-id="element-3203">Banovo Brdo</option>
                    <option data-id="element-3204">Novi Beograd</option>
                  </select>
                </div>
              </div>
              <div data-id="element-3205">
                <label className="block text-xs font-bold text-text-secondary uppercase mb-1" data-id="element-3206">
                  Training Flow
                </label>
                <select className="w-full bg-background border border-white/10 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-accent-primary" data-id="element-3207">
                  <option data-id="element-3208">Kitchen Staff (12 modules)</option>
                  <option data-id="element-3209">Shift Manager (15 modules)</option>
                  <option data-id="element-3210">Custom...</option>
                </select>
              </div>

              <div className="space-y-2 pt-2 border-t border-white/5" data-id="element-3211">
                <label className="flex items-center gap-2 cursor-pointer" data-id="element-3212">
                  <input type="checkbox" className="rounded border-white/10 bg-background text-accent-primary focus:ring-accent-primary" defaultChecked data-id="element-3213" />
                  <span className="text-sm" data-id="element-3214">Send welcome via WhatsApp</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer" data-id="element-3215">
                  <input type="checkbox" className="rounded border-white/10 bg-background text-accent-primary focus:ring-accent-primary" defaultChecked data-id="element-3216" />
                  <span className="text-sm" data-id="element-3217">Notify HR when completed</span>
                </label>
              </div>
            </div>

            <div className="flex justify-end gap-3" data-id="element-3218">
              <Button variant="secondary" onClick={() => setShowAddModal(false)} data-id="element-3219">
                Cancel
              </Button>
              <Button onClick={() => setShowAddModal(false)} data-id="element-3220">
                Start Onboarding
              </Button>
            </div>
          </Card>
        </div>}
    </div>;
}